import ClassNames from '@streamloots/classnames';
import { TranslateInterface } from 'utils/translation';
import AvatarImage from 'components/avatar-image';
import { Badge } from 'ui-library/badge';
import { DateUtils } from 'domain/date-utils';
import { FeedActions } from './FeedActions';
import theme from './feed-list.scss';
import { useFeedList } from './useFeedList';

const classNames = ClassNames(theme);

interface AutomaticFeed {
  feedId?: never;
  feedLikedCount?: never;
  feedCommentCount?: never;
}

interface RegularFeed {
  feedId: string;
  feedLikedCount: number;
  feedCommentCount: number;
}

type FeedType = AutomaticFeed | RegularFeed;

export type FeedHeaderProps = TranslateInterface &
  FeedType & {
    createdAt: Date;
    lastVisitAt?: string;
    onlySubscribers?: boolean;
  };

export const FeedHeader = ({
  createdAt,
  onlySubscribers,
  feedId,
  feedLikedCount,
  feedCommentCount,
  t,
}: FeedHeaderProps): JSX.Element => {
  const { page } = useFeedList();

  return (
    <div className={classNames('feed-detail__header')}>
      <div className={classNames('feed-detail__header__info')}>
        <AvatarImage
          src={page.owner?.profile.avatarImageUrl}
          className={classNames('feed-detail__header__info__avatar')}
        />
        <div>
          <div className={classNames('feed-detail__header__info__slug')}>{page.slug}</div>
          <div className={classNames('feed-detail__header-time-badges')}>
            <span className={classNames('feed-detail__header__info__time')}>
              {/* <NewLabel date={lastVisitAt} expiresInHours={0.1} /> */}
              {DateUtils.fromNow(createdAt)}
            </span>
            {onlySubscribers && <Badge color="warning" label={t('pageFeed:onlyForSubscribers')} />}
          </div>
        </div>
      </div>
      {feedId && (
        <FeedActions
          t={t}
          feedId={feedId}
          feedLikedCount={feedLikedCount ?? 0}
          feedCommentCount={feedCommentCount ?? 0}
        />
      )}
    </div>
  );
};
